import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import Auth from './auth.store';
import AlertMessageStore from './alert-message.store';
import SortStore from '@/tsort/store/sort.store';
import SettingStore from '@/common/store/setting.store';

Vue.use(Vuex);

export default new Store({
  modules: {
    Auth,
    AlertMessageStore,
    SortStore,
    SettingStore
  },
  state: {
    modalMode: false,
    networkConnectionMode: true,
    changeWorkTypeMode: false,
    switchingBtnMode: false
  },
  mutations: {
    setModalMode(state, value) {
      state.modalMode = value;
    },
    setNetworkConnectionMode(state, value) {
      state.networkConnectionMode = value;
    },
    setChangeWorkTypeMode(state, value) {
      state.changeWorkTypeMode = value;
    },
    setSwitchingBtnMode(state, value) {
      state.switchingBtnMode = value;
    }
  },
  getters: {
    getModalMode: (state) => {
      return state.modalMode;
    },
    getNetworkConnectionMode: (state) => {
      return state.networkConnectionMode;
    },
    getChangeWorkTypeMode: (state) => {
      return state.changeWorkTypeMode;
    },
    getSwitchingBtnMode: (state) => {
      return state.switchingBtnMode;
    }
  }
});
